module.exports = __webpack_public_path__ + "img/tcl2.d74c6abf.png";